import type { LibraryBlockDef } from '../types';
import type { FormBuilderBlockIconKey } from './blockIconTypes';
import { FM_BLOCK_ICON_BY_ID } from './blockIconMap';

const ICON_BY_ID: Record<string, FormBuilderBlockIconKey | undefined> = FM_BLOCK_ICON_BY_ID;

export function resolveFormBuilderBlockIcon(block: Pick<LibraryBlockDef, 'id' | 'icon'>): FormBuilderBlockIconKey {
  if (block.icon) return block.icon;
  return ICON_BY_ID[block.id] ?? 'FileText';
}
